import React from 'react';
import PropTypes from 'prop-types';

const ImageMapper = ({areas,onClick,...rest}) => (
    <map name="image-map">
        {areas.map(area => <area {...area} key={area.title+area.side} onClick={(e)=>onClick(e,area.title,area.side)}/>)}
    </map>
  );

ImageMapper.propTypes = {
    /** array of areas for map, item in array  {alt ,title,side,coords ,shape} * */
    areas:PropTypes.array.isRequired
};
ImageMapper.defaultProps = {};

export default ImageMapper;
